import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EncryptDTO  {
    _originalTypeClassName = "zERP.BO.EncryptDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EncryptDTO.translate = translateService;
}
this.outputFile = null;
this.EncryptDTOKey = null;
this._key = this.EncryptDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
outputFile:any;
private _EncryptDTOKey:any;
get EncryptDTOKey(): any {
    return this._EncryptDTOKey;
  }
set EncryptDTOKey(value: any) {
    this._EncryptDTOKey = value;
    this._key = value;
  }

static GetEncryptExtention(): any{return ".pgp";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.EncryptDTOKey == null || $this.EncryptDTOKey == 0;
            }


}